import React from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const SupportWebsiteModal = ({ show, onClose }) => {
  const handlePatreonClick = () => {
    window.open('https://www.patreon.com/hearthcards', '_blank');
  };

  const handleKofiClick = () => {
    window.open('https://ko-fi.com/hearthcards', '_blank');
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Support the Website</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <Image 
          src="/images/users/pictures/66c760d0763594.21099192.jpg" 
          roundedCircle 
          className="mb-3"
          alt="Nikko's profile picture"
          style={{ width: '200px', height: '200px', objectFit: 'cover' }}
        />
        <p className="mb-4 text-start">
          Hi! I'm Nikko, the sole creator and maintainer of HearthCards for the past 12 years.
          Running and updating this website costs not only my time but also money.
          HearthCards doesn't feature any ads, and I make virtually nothing from it
          as any money donated is dedicated to covering the site's running costs.
          If you'd like to help with that and want the development of HearthCards to continue, there are two options:
        </p>
        <ul className="list-unstyled mb-4 text-start">
          <li><strong>Patreon:</strong> Best suited for automatic monthly support (though you can join and unsubscribe for a one-time donation)</li>
          <li><strong>Ko-Fi:</strong> Perfect for one-time donations</li>
        </ul>
        <div className="d-flex justify-content-center">
          <Button 
            variant="primary" 
            onClick={handlePatreonClick} 
            className="me-2"
          >
            Support on Patreon
          </Button>
          <Button 
            variant="info" 
            onClick={handleKofiClick}
          >
            Support on Ko-Fi
          </Button>
        </div>
        <p className="mt-4 text-start">
          Every bit of support helps keep HearthCards running and improving. Thank you for considering!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SupportWebsiteModal;